import { AppTable, AppTableColumn } from '../../../_models/models';

export const billsTable: AppTable = new AppTable('billsTable', 0, 10, 'totalAmount', 'asc', true, true);

export const billsTableColumns: AppTableColumn[] = [
  {id: 'billDate', prop: 'billDate', displayName: 'Payment Period', type: 'date-full-month-year', isSortEnabled: false},
  {id: 'billAmount', prop: 'amount', displayName: 'Amount', type: 'currency', isSortEnabled: false},
];
